import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import store from "./store";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import loadDrillDown from "highcharts/modules/drilldown";
// This thing has a lot of features we are not using ... more info:
//   https://github.com/MatteoGabriele/vue-analytics
import VueAnalytics from "vue-analytics";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import Vuelidate from "vuelidate";

// router setup
import routes from "./routes/routes";

stockInit(Highcharts);
loadDrillDown(Highcharts);

import { checkSubscription } from "./utils/auth0";
import { checkForConnection } from "./utils/appcues";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

router.afterEach(to => {
  //we don't need to check for a subscription when hitting the auth0-callback
  if (!to.path.includes("auth0-callback") && !to.path.includes("error")) {
    checkSubscription(to, router);
  }
  //do a check for connection exists
  checkForConnection();
});

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(HighchartsVue);
Vue.use(VueAnalytics, {
  id: "UA-11093886-9",
  checkDuplicatedScript: true,
  router, // auto-tracking
  fields: {
    siteSpeedSampleRate: 10
  }
});
Vue.use(Vuelidate);

// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
  get() {
    return this.$root.Chartist;
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  data: {
    Chartist: Chartist
  },
  watch: {
    $route: () => {
      window.Appcues.page();
    }
  }
});
